import combine from '../services/combine-service';
import moment from "moment";
const invoices = {
  all: [],
  unpaidInv: [],
  unaprovedInv: [],
  unsentInv: []
};


export default function(state = invoices, action) {
  var payload;
  var invpop;
  switch (action.type) {
    case 'invoices - invoices':
      invpop = invoicepopulate(action.payload);
      if(action.payload.length){
        var latestdate = action.payload
        .map(invoice => {
          console.log('invoice test', invoice.id, invoice.periodenddate)
          return invoice.periodenddate;
        })
        .reduce((a, b) => (a > b ? a : b));
      }else{
        var latestdate = moment().startOf('year').format('YYYY-MM-DD')
      }

      return {
        ...state,
        lastenddate: latestdate,
        all: action.payload,
        unpaidInv: invpop.unpaid,
        unaprovedInv: invpop.unaproved,
        unsentInv: invpop.unsent
      };
      break;
    case 'Update > invoices':
      return {
        ...state,
        all: combine(state.all, action.payload, 'id', action.deletestatus)
      };
      break;
    case 'Feathers Update > invoices':
      return {
        ...state,
        all: combine(state.all, action.payload, 'id', action.deletestatus)
      };
      break;
    case 'invoices - invoiceReducer':
      return {
        ...state,
        all: action.payload
      };
      break;

    default:
      return state;
  }
}
const invoicepopulate = invoices => {
  let unpaid = [];
  let unaproved = [];
  let unsent = [];
  invoices.map(invoice => {
    if (invoice.paidamount < invoice.amount) {
      //  console.log('unpaid Invoice', invoice);
      unpaid = unpaid.concat(invoice);
    }
    if (invoice.approved === null) {
      unaproved = unaproved.concat(invoice);
    }
    if (invoice.submitdate === null) {
      unsent = unsent.concat(invoices);
    }
  });
  return { unpaid: unpaid, unaproved: unaproved, unsent: unsent };
};



// WEBPACK FOOTER //
// ./src/reducers/invoice-reducer.js